import Vue from 'vue';
import _ from 'lodash';
import { db, docsFromSnapshot, docFromSnapshot } from '@/firebase';

const state = {
  resources: {}
};

const getters = {
  resources: state => state.resources,
  resourcesList: state => Object.values(state.resources),
  resourceById: state => id => state.resources[id]
};

const mutationTypes = {
  SET_RESOURCES: 'SET_RESOURCES',
  SET_RESOURCE: 'SET_RESOURCE',
  REMOVE_RESOURCE: 'REMOVE_RESOURCE'
};

const actions = {
  async createResource(context, resource) {
    resource.storeId = context.rootGetters['stores/storeId'];
    resource.timestamp = +new Date();
    resource.created = resource.timestamp;

    const ref = db.collection('resources').doc();
    resource._id = ref.id;

    await ref.set(resource);

    context.commit(mutationTypes.SET_RESOURCE, resource);
  },
  async fetchResources(context) {
    const snap = await db
      .collection('resources')
      .where('storeId', '==', context.rootGetters['stores/storeId'])
      .get();

    context.commit(mutationTypes.SET_RESOURCES, docsFromSnapshot(snap));
  },
  async fetchResource(context, id) {
    const snap = await db
      .collection('resources')
      .doc(id)
      .get();

    context.commit(mutationTypes.SET_RESOURCE, docFromSnapshot(snap));
  },
  async updateResource(context, resource) {
    resource.timestamp = +new Date();

    await db
      .collection('resources')
      .doc(resource._id)
      .set(resource);

    context.commit(mutationTypes.SET_RESOURCE, resource);
  },
  async deleteResource(context, resource) {
    // TODO referential integrity check against events/bookings
    await db
      .collection('resources')
      .doc(resource._id)
      .delete();

    context.commit(mutationTypes.REMOVE_RESOURCE, resource._id);
  }
};

const mutations = {
  [mutationTypes.SET_RESOURCES](state, resources) {
    state.resources = resources;
  },
  [mutationTypes.SET_RESOURCE](state, resource) {
    Vue.set(state.resources, resource._id, resource);
  },
  [mutationTypes.REMOVE_RESOURCE](state, id) {
    state.resources = _.omit(state.resources, id);
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
